<template>
  <li class="dropdown navbar-user nav-item">
    <a
      href="javascript:;"
      class="dropdown-item f-s-14"
      data-toggle="dropdown"
    >
      <i class="fa fa-plus" />
      <b class="caret" />
    </a>
    <ul class="dropdown-menu">
      <li class="dropdown-item">
        <a
          href="#"
          @click.prevent="toggleCreateLeadButton()"
        >
          <i class="fa fa-plus m-l-1 m-r-4" /> {{ __('Adicionar Lead') }}
        </a>
      </li>
      <li class="dropdown-item">
        <a
          href="#"
          @click.prevent="toggleImportLeadButton()"
        >
          <i class="fa fa-cloud-upload m-r-2" /> {{ __('Importar Leads') }}
        </a>
      </li>
      <li class="dropdown-item">
        <a
          href="#"
          @click.prevent="toggleCreateDealButton()"
        >
          <i class="fa fa-dollar m-l-3 m-r-5" /> {{ __('Novo Negócio') }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  data () {
    return {
      lead: null,
    };
  },

  mounted () {
    Bus.$on('leadRetrieved', (lead) => this.lead = lead);
  },

  methods: {
    toggleCreateLeadButton () {
      Bus.$emit('createLeadButtonToggled');
    },

    toggleImportLeadButton () {
      Bus.$emit('importLeadButtonToggled');
    },

    toggleCreateDealButton () {
      Bus.$emit('createDealButtonToggled', this.lead);
    },
  },
};
</script>
